export const queryKeys = {
  // Appointments
  appointments: {
    all: ['appointments'] as const,
    lists: () => [...queryKeys.appointments.all, 'list'] as const,
    list: (filters: { startDate?: string; endDate?: string; appointmentTypeIds?: string[]; targetUserId?: string }) =>
      [...queryKeys.appointments.lists(), filters] as const,
    details: () => [...queryKeys.appointments.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.appointments.details(), id] as const,
    byJob: (jobId: string) => [...queryKeys.appointments.all, 'job', jobId] as const,
    byCustomer: (customerId: string) => [...queryKeys.appointments.all, 'customer', customerId] as const,
    recentActivity: () => [...queryKeys.appointments.all, 'recent-activity'] as const,
  },

  // Appointment Types
  appointmentTypes: {
    all: ['appointmentTypes'] as const,
    list: (businessId?: string) => [...queryKeys.appointmentTypes.all, 'list', businessId] as const,
    details: () => [...queryKeys.appointmentTypes.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.appointmentTypes.details(), id] as const,
  },

  // Customers
  customers: {
    all: ['customers'] as const,
    lists: () => [...queryKeys.customers.all, 'list'] as const,
    list: (filters: { searchTerm?: string; page?: number; pageSize?: number; statuses?: number[] }) =>
      [...queryKeys.customers.lists(), filters] as const,
    details: () => [...queryKeys.customers.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.customers.details(), id] as const,
    count: (filters?: object) => [...queryKeys.customers.all, 'count', filters] as const,
    bySalesPerson: (salesPersonId: string) => [...queryKeys.customers.all, 'salesPerson', salesPersonId] as const,
  },

  // Jobs
  jobs: {
    all: ['jobs'] as const,
    lists: () => [...queryKeys.jobs.all, 'list'] as const,
    list: (filters?: object) => [...queryKeys.jobs.lists(), filters] as const,
    details: () => [...queryKeys.jobs.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.jobs.details(), id] as const,
    byCustomer: (customerId: string) => [...queryKeys.jobs.all, 'customer', customerId] as const,
  },

  // Businesses
  businesses: {
    all: ['businesses'] as const,
    list: () => [...queryKeys.businesses.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.businesses.all, 'detail', id] as const,
    users: (businessId: string) => [...queryKeys.businesses.all, businessId, 'users'] as const,
    current: () => [...queryKeys.businesses.all, 'current'] as const,
  },

  // Forms
  forms: {
    all: ['forms'] as const,
    list: () => [...queryKeys.forms.all, 'list'] as const,
    detail: (id: number) => [...queryKeys.forms.all, 'detail', id] as const,
    responses: (formId: number, documentId: string) =>
      [...queryKeys.forms.all, 'responses', formId, documentId] as const,
    jobResponses: (jobId: string) => [...queryKeys.forms.all, 'jobResponses', jobId] as const,
  },

  // Documents
  documents: {
    all: ['documents'] as const,
    lists: () => [...queryKeys.documents.all, 'list'] as const,
    list: (filters?: { customerId?: string; jobId?: string }) =>
      [...queryKeys.documents.lists(), filters] as const,
    detail: (id: string) => [...queryKeys.documents.all, 'detail', id] as const,
    byCustomer: (customerId: string) => [...queryKeys.documents.all, 'customer', customerId] as const,
    byJob: (jobId: string) => [...queryKeys.documents.all, 'job', jobId] as const,
  },

  // Users
  users: {
    all: ['users'] as const,
    list: () => [...queryKeys.users.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.users.all, 'detail', id] as const,
    current: () => [...queryKeys.users.all, 'current'] as const,
  },
};
